// https://redux.js.org/tutorials/fundamentals/part-8-modern-redux#using-configurestore
import { configureStore } from "@reduxjs/toolkit";
//Reducers
import aiCommentServiceSettingReducer from "./pages/aiCommentServiceSetting/sliceAiCommentService";
import appConnectReducer from "./pages/appConnect/sliceAppConnect";
import homeReducer from "./pages/home/homeSlice";
import commentRegStatusReducer from "./pages/home/sliceCommentRegStatus";
import reviewStatReducer from "./pages/home/sliceReviewStat";
import reviewReducer from "./pages/review/sliceReview";
import reviewOneReducer from "./pages/review/sliceReviewOne";
import reviewSettingAdditionalCommentReducer from "./pages/review/sliceReviewSettingAdditionalComment";
import reviewSettingAdditionalCommentOneReducer from "./pages/review/sliceReviewSettingAdditionalCommentOne";
import reviewSettingDaysReducer from "./pages/review/sliceReviewSettingDays";
// import ceoReducer from "./slice/sliceCeo";
import ceoAccountStatusReducer from "./reducers/CeoAccountStatus";
import ceoStoreReducer from "./pages/ceoStore/sliceCeoStore";
import loadingReducer from "../src/slice/LoadingSlice";
import ceoStatusReducer from "./reducers/CeoStatus";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from "react-redux";

// import popupReviewReducer from "./pages/review/popupReviewSlice";

export const store = configureStore({
  reducer: {
    // fetch api
    home: homeReducer,
    CommentRegStatus: commentRegStatusReducer,
    AppConnect: appConnectReducer,
    AiCommentServiceSetting: aiCommentServiceSettingReducer,
    Ceo: ceoAccountStatusReducer,
    CeoStore: ceoStoreReducer,
    ReviewStat: reviewStatReducer,
    Review: reviewReducer,
    ReviewOne: reviewOneReducer,
    ReviewSettingAdditionalComment: reviewSettingAdditionalCommentReducer,
    ReviewSettingAdditionalCommentOne: reviewSettingAdditionalCommentOneReducer,
    ReviewSettingDays: reviewSettingDaysReducer,
    Loading: loadingReducer,
    CeoStatus: ceoStatusReducer
    

    // ui
    // PopupReview: popupReviewReducer,
  },
});

const { dispatch } = store;

const useSelector = useAppSelector;

const useDispatch = () => useAppDispatch();
export { dispatch, useSelector, useDispatch };
